import { put, call, select, takeLatest } from "redux-saga/effects";
import { userAuthenticate, userRefresh, userLogout, isLoggedInPost2 } from "../api/ssoApi";
import * as types from "../constants/actionTypes";
import * as msgs from "../constants/textConstants";
import * as Tools from "../helpers/Tools";
import Cookies from "cookies-js";
import { logAPI } from "../api/andyliticsApi";
import { getDomain } from "../helpers/Tools";
import { authContext } from "../adalConfig";
import { ConvertToken } from "../api/localApi";

export function* watchUserAuthenticate() {
    yield takeLatest([types.USER_AUTHENTICATE], authorize);
    yield takeLatest([types.USER_AUTHENTICATE_REFRESH], refresh);
    yield takeLatest([types.VERIFY_LOGIN], verifyLogin);
    yield takeLatest([types.LOGOUT], logoutRedirect);
    yield takeLatest([types.LOGIN_FORM_SUCCESS], loginSuccess);
    yield takeLatest([types.REFRESH_TOKEN], refreshToken);
    yield takeLatest([types.SET_AD_ID_TOKEN], ADAuthenticated);
    yield takeLatest([types.POST_LOGIN_START], PostLoginAsyncDataLoad);
    yield takeLatest([types.APP_START], PostLoginAsyncDataLoad);
    yield takeLatest([types.ADAL_TOKEN_REFRESH], adalTokenRefresh);
}
export function* adalTokenRefresh(data) {
    var domain = yield select((state) => state.domain);
    if (domain.adt) {
        var oNewToken = yield Tools.safeCall(ConvertToken, domain.adt, domain.un);
        yield put({ type: types.SET_HEALTH_SOURCE_TOKEN, result: oNewToken.result });
    }
}

export function* PostLoginAsyncDataLoad(data, sLanID) {
    const start = new Date();
    try {
        yield put({ type: types.POSTLOGIN_PROCESS_START });
        yield put({ type: types.POSTLOGIN_PROCESS_END });
    }
    catch (ex) {
        console.error(ex);
        yield put({ type: types.POSTLOGIN_PROCESS_END });
        logAPI("Saga.SSO.ADAuthenticated.Failure", start, null, data);
    }
}

function formatZeroes(sVal) {
    if (sVal.length < 2) {
        sVal = '0' + sVal;
    }
    return sVal;
}

export function* ADAuthenticated(data) {
    const start = new Date();
    try {
        var domain = yield select((state) => state.domain);
        if (domain.adt) {
            yield put({ type: types.START_TOKEN_EXCHANGE });
            var oNewToken = yield Tools.safeCall(ConvertToken, domain.adt, domain.un);
            if (oNewToken && oNewToken.result) {
                yield put({ type: types.SET_HEALTH_SOURCE_TOKEN, result: oNewToken.result });
                logAPI("Saga.SSO.ADAuthenticated", start, null, data);
                domain = yield select((state) => state.domain);
                yield onUserAuthenticateSuccess(oNewToken.result, oNewToken.result.LanID);
                yield put({ type: types.USER_AUTHENTICATE_SUCCESS, userData: oNewToken.result });
                yield put({ type: types.END_TOKEN_EXCHANGE });
                yield put({ type: types.POST_LOGIN_START });
            }
            else {
                logAPI("Saga.SSO.ADAuthenticated.Failure", start, null, oNewToken);
            }
        }
    }
    catch (ex) {
        console.error(ex);
        logAPI("Saga.SSO.ADAuthenticated.Failure", start, null, data);
    }

}

export function* handleRedirect(reDirectURL) {
    const start = new Date();
    const history = yield select((state) => state.session.history);
    const domain = yield select((state) => state.domain);
    if (typeof window !== 'undefined') {
        if (reDirectURL && window.location.pathname !== reDirectURL) {
            const reDirectURLWithQP = domain.qp ? reDirectURL + domain.qp : reDirectURL;
            history.push(reDirectURLWithQP);
            logAPI("Saga.SSO.Redirect", start, null, reDirectURLWithQP);
        }
        yield put({ type: types.CLEAR_REDIRECT_URL });

    }

}

export function* refreshToken() {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    if (domainData.rt) {
        yield put({ type: types.USER_AUTHENTICATE_REFRESH, refresh_token: domainData.rt });
        logAPI("Saga.SSO.RefreshToken.Get", start, null);
    } else {
        //Adding more log to validate mobile issue for linking
        logAPI("Saga.SSO.RefreshToken.Error.NoRefreshToken", start, null);
    }
}

export function* loginSuccess(paylog) {
    //debugger;
    try {
        const sDomain = yield getDomain();
        Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
    }
    catch (err) {
        console.error(err);
    }
}


export function* authorize(payload) {
    const start = new Date();
    try {
        const response = yield call(userAuthenticate, payload);
        yield onUserAuthenticateSuccess(response);
        if (response && response.access_token) {
            yield put({ type: types.LOGIN_FORM_SUCCESS, error: null, isWaiting: false });
            logAPI("Saga.SSO.Authenticate.Login", start, null);
        }
        else {
            logAPI("Saga.SSO.Authenticate.Login.Failure", start, null);
        }
    }
    catch (error) {
        console.error(error);
        logAPI("Saga.SSO.Authenticate.Login.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }
}

export function* CallIsLoggedIn(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        const response = yield call(isLoggedInPost2, domain.t);
        yield onUserAuthenticateSuccess(response);
        logAPI("Saga.SSO.IsLoggedIn", start, null, response);
    }
    catch (error) {
        console.error(error);
        logAPI("Saga.SSO.IsLoggedIn.Failure", start, null, null);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }
}

var bInRefresh = false;

export function* refresh(payload) {
    const start = new Date();
    try {
        const response = yield call(userRefresh, payload);
        //debugger;
        if (response && response.access_token) {
            yield onUserAuthenticateSuccess(response);
            logAPI("Saga.SSO.Refresh", start, null);
        }
        else {
            yield put({ type: types.REFRESH_TOKEN_FAILURE, userData: response, responseError: response.error, isWaiting: false });
            logAPI("Saga.SSO.Refresh.Failure", start, null);
        }
        if (response && !response.IsLoggedIn) {
            yield put({ type: types.VERIFY_LOGIN, error: null, isWaiting: false });
            logAPI("Saga.SSO.Refresh.Failure", start, null);
        }
    }
    catch (error) {
        console.error(error);
        bInRefresh = false;
        logAPI("Saga.SSO.Refresh.Failure", start, null, null);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }

}

export function* onUserAuthenticateSuccess(response, sLanID) {
    const start = new Date();
    try {
        if (response && response.access_token) {
            yield PostLoginAsyncDataLoad(null, sLanID);
            yield put({ type: types.USER_AUTHENTICATE_SUCCESS, userData: response, responseError: response.error, isWaiting: false });
            logAPI("Saga.SSO.OnUserAuthenticateSuccess", start, null);
        }
        else {
            console.error("Saga.SSO.OnUserAuthenticateSuccess.Failure", response);
            logAPI("Saga.SSO.OnUserAuthenticateSuccess.Failure", start, null);
            yield put({ type: types.USER_AUTHENTICATE_FAILURE, userData: response, responseError: response.error_description ? response.error_description : response.error && response.error === "invalid_grant" ? msgs.LoginInvalidGrantMessage : response.error, isWaiting: false });
        }
    }
    catch (err) {
        console.error("Saga.SSO.OnUserAuthenticateSuccess.FailureCatch", err);
        logAPI("Saga.SSO.OnUserAuthenticateSuccess.Failure", start, null, err);
    }
}

export function* verifyLogin(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        const ssoResponse = yield call(isLoggedInPost2, domain.t);
        yield onUserAuthenticateSuccess(ssoResponse);
        const loggedin = ssoResponse.IsLoggedIn;
        if (loggedin === false) {
            console.log("LOGOUT");
            yield put({ type: types.LOGOUT, userDetails: {}, DontClearRedirectURL: payload.DontClearRedirectURL });
            logAPI("Saga.SSO.VerifyLogin", start, null);
        }
        else {
            if (payload.forceRefresh) {
                yield put({ type: types.REFRESH_TOKEN });  // this allows us to refresh any changes that may have been to the account by an external site
            }
        }
        yield put({ type: types.VERIFY_LOGIN_COMPLETED });
    }
    catch (error) {
        console.error("Saga.SSO.VerifyLogin.Failure", error);
        logAPI("Saga.SSO.VerifyLogin.Failure", start, null, JSON.stringify(error));
        yield put({ type: types.VERIFY_LOGIN_COMPLETED });
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }
}

export function* logoutRedirect(data) {
    const start = new Date();
    try {
        // clear proxy on logout
        const sDomain = getDomain();
        Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
        const history = yield select((state) => state.session.history);
        try {
            const oIgnore = yield call(userLogout);
            const domain = yield select((state) => state.domain);
            Cookies.expire('location_' + domain.un, { domain: Tools.getDomain(location.href) });
        }
        catch (e) { console.log(e); }

        yield put({ type: types.LOGOUT_COMPLETED, logoutMessage: data.logoutMessage }); // this forces the UI to update

        if (window.location.pathname !== "/login" && !data.DontClearRedirectURL && window.location.pathname !== "/reset") {
            try {
                //alert("Manually switching to Login page");
                //debugger;
                history.push("/login");
            }
            catch (ex) {
                console.error(ex);
                logAPI("Saga.SSO.LogoutRedirect.Failure", start, null, JSON.stringify(ex));
            }
        }

        logAPI("Saga.SSO.LogoutRedirect", start, null);
        yield put({ type: types.USER_LOGGED_OUT, DontClearRedirectURL: data.DontClearRedirectURL, logoutMessage: data.logoutMessage });

        authContext.logOut();
    }
    catch (err) {
        console.error(err);
        logAPI("Saga.SSO.LogoutRedirect.Failure", start, null, JSON.stringify(err));
    }
}